module.exports = __webpack_public_path__ + "img/feefo_logo_yellow.ec17994.webp";